import {createSelector} from "reselect";

const selectUser = state => state.user;

export const selectUserInfo = createSelector(
    [selectUser],
    user => user.info
);
export const selectIsDemo = createSelector(
    [selectUser],
    user => user.isDemo
);
export const selectToken = createSelector(
    [selectUser],
    user => user.token
);
export const selectIosAndroid = createSelector(
    [selectUser],
    user => user.IosAndroid
);
export const selectFirstCheck = createSelector(
    [selectUser],
    user => user.firstCheck
);